t = require('views/internal/teacup-with-helpers')('header_user')

module.exports = t.renderable ({ hasCrown, showChannelPicker, escapedReturnUrl, isEnterpriseAdmin, upsellEnabled, hasAppcuesNews }) ->
  t.a '.header-btn.js-open-add-menu', { href: '#', 'aria-label': t.l('create-board-or-org') }, ->
    t.span '.header-btn-icon.icon-lg.icon-add.light'

  if upsellEnabled
    if hasAppcuesNews
      t.a '.header-btn.header-appcues.js-open-header-appcues-menu', { href: '#', 'aria-label': t.l('open-tips-menu') }, ->
        t.span '.header-btn-icon.icon-lg.icon-lightbulb-lit.light'
    else
      t.a '.header-btn.header-info.js-open-header-info-menu', { href: '#', 'aria-label': t.l('open-information-menu') }, ->
        t.span '.header-btn-icon.icon-lg.icon-information.light'

  t.a '.header-btn.header-notifications.js-open-header-notifications-menu', { href: '#', 'aria-label': t.l('notifications-menu') }, ->
    t.span '.header-btn-icon.icon-lg.icon-notification.light'

  if isEnterpriseAdmin
    t.a '.header-btn.header-enterprise-dashboard.js-open-enterprise-dashboard-menu', { href: '#', 'aria-label': t.l('enterprise-dashboard') }, ->
      t.span '.header-btn-icon.icon-lg.icon-enterprise-dashboard.light'

  if showChannelPicker
    t.a '.header-btn.header-btn-channel-picker.js-open-channel-picker', { href: '#', 'aria-label': t.l('switch-channels') }, ->
      t.span '.header-btn-icon.icon-lg.icon-gear.light'

  t.a '.header-btn.header-avatar.js-open-header-member-menu', { href: '#', 'aria-label': t.l('member-menu') }, ->
    t.span { class: t.classify({
      'has-crown': hasCrown,
      'member': true
      })
    }



// WEBPACK FOOTER //
// ./app/scripts/views/templates/header_user.coffee